import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import GenericButton from '../../../components/common/button';
import EditIcon from '../../../img/myProfile/EditIcon';

const ProfileInformation = ({ onClickEditButton }) => {
  const { userData } = useSelector((state) => state?.user);
  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#1D90BA' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#1D90BA' };
  }
  return (
    <div className="profile-information-my-profile">
      <Card className="card-container">
        <div className="top-section">
          <div className="user-icon">
            {userData?.FirstName[0] + userData?.LastName[0]}
          </div>
          <div className="name-email-container">
            <div className="name">{`${userData?.FirstName}${
              userData?.MiddleName ? ' ' + userData?.MiddleName + ' ' : ' '
            }${userData?.LastName}`}</div>
            <div className="email">{userData?.UserID || '-'}</div>
          </div>
          <div className="user-type-data-container">
            <div className="heading">User Type</div>
            <div className="data">
              {userData?.UserType
                ? userData?.UserType === 'Client'
                  ? 'Employer'
                  : userData?.UserType
                : '-'}
            </div>
          </div>
        </div>
        <div className="info-section">
          <div className="heading">
            <Row>
              <Col md={8}>Profile Information</Col>
              <Col md={4} className="text-right">
                <GenericButton
                  onClick={onClickEditButton}
                  variant="secondary"
                  className="height-32 edit-profile-button"
                >
                  {' '}
                  <EditIcon
                    fillColor={themeValuesObject['Secondary-1'] || '#1d90ba'}
                  />{' '}
                  Edit{' '}
                </GenericButton>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <Col>
                <div className="data-heading">Contact Number</div>
                <div className="data-value">
                  {userData?.CellPhone ? '+1 ' + userData?.CellPhone : '-'}
                </div>
              </Col>
              {/*CellPhone JobTitle EmployeeId Address */}
              <Col>
                <div className="data-heading">Job Title/Role</div>
                <div className="data-value">{userData?.JobTitle || '-'}</div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="data-heading">Employee ID</div>
                <div className="data-value">{userData?.EmployeeId || '-'}</div>
              </Col>
              <Col>
                <div className="data-heading">Location / City / Region</div>
                <div className="data-value">
                  {userData?.Address ? userData?.Address : '-'}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ProfileInformation;
